export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-01.2ecffa4a.jpg";